import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BookingEsimState = {
  value: BookingDetails['esim'] | null;
};

const initialState: BookingEsimState = {
  value: null,
};

function setBookingEsimFunction(state: BookingEsimState, action: PayloadAction<BookingEsimState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingEsim',
  initialState,
  reducers: {
    setBookingEsim: setBookingEsimFunction,
    resetState: resetStateFunction,
  },
});

export const { setBookingEsim, resetState } = slice.actions;
export default slice.reducer;
